export default {
  user: undefined,
  authProvider: undefined,
  canChangeEmail: undefined,
  hasPassword: undefined
}
